// extracted by mini-css-extract-plugin
export default {"pastilleContainer":"PrintCardsButton_pastilleContainer__K2oao","label":"PrintCardsButton_label__PncFG"};